import React from "react";
import "../../assets/css/different.css";
import { motion } from "framer-motion";

export default function Different() {

  const features = [
    { text: "Personalized travel planning", icon: "🧭" },
    { text: "Strong hotel & travel network", icon: "🏨" },
    { text: "End-to-end trip management", icon: "📦" },
    { text: "Affordable pricing with premium experience", icon: "💎" }
  ];

  return (
    <section className="different">

      {/* Title */}
      <motion.h2 
        className="diff-title"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
      >
        What Makes Us <span>Different?</span>
      </motion.h2>

      {/* Scroll Strip */}
      <div className="diff-scroll">

        <div className="diff-track">
          {[...features, ...features].map((item, i) => (
            <motion.div 
              className="diff-item"
              key={i}
              whileHover={{ scale: 1.1, rotate: 1 }}
            >
              <span className="icon">{item.icon}</span>
              {item.text}
            </motion.div>
          ))}
        </div>

      </div>

    </section>
  );
}